import React from "react";
import { Grid, Section, Typography, Divider } from "../../core";
import { MixStyle, media, theme } from "../../styles";
import EditConversion from "../../components/EditConversion";
import styled from "styled-components";

const { colors } = theme;
const Container = styled.div`
  margin: 50px 0px;
`;
const TittleWraper = styled.div`
  ${MixStyle.flexCenter};
  h1 {
    ${media.minitablet`font-size:36px;`};
  }
  .d-inline--block {
    display: inline-block;
  }
`;
const EditConversionContract = () => {
  return (
    <Container>
      <Grid>
        <Section padding="10px 50px">
          <TittleWraper>
            <Typography
              className="d-inline--block"
              align="center"
              as="h1"
              color={colors.darkPink}
              weight="bold"
            >
              Edit Conversion Contract
              <Divider />
            </Typography>
          </TittleWraper>
          <EditConversion />
        </Section>
      </Grid>
    </Container>
  );
};

export default EditConversionContract;
